import React from 'react';
import {connect} from 'react-redux';

const Style = props => {
    let style = typeof props.configuration?.custom?.style === 'string' ? props.configuration.custom.style : null;

    return (
        style ? <style>{style}</style> : null
    );
};

const mapStateToProps = state => {
    return {...state};
}

export default connect(mapStateToProps)(Style);